import { useState, useEffect } from 'react';
import '../Anniversary/AnniversarySection.css';
import '../../Pages/Products.css';
import { openWhatsApp, buildPackageMessage } from '../../Hooks/whatsapp';

const OneSectionDefault = ({ DataPackages, sectionTitle = "Section Title", onNavigate }) => {
const [isOpenView,setIsOpenView] = useState(false);
const [selectedPackage,setSelectedPackage] = useState(null);
const [currentSlide, setCurrentSlide] = useState(0);

// Preload first few images for better performance
useEffect(() => {
  if (DataPackages && DataPackages.length > 0) {
    const imagesToPreload = DataPackages.slice(0, 4).map(pkg => pkg.image);
    imagesToPreload.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });
    
    return () => {
      imagesToPreload.forEach(src => {
        const links = document.querySelectorAll(`link[href="${src}"]`);
        links.forEach(link => link.remove());
      });
    };
  }
}, [DataPackages]);

const openView =  (pkg)=>{
  if (pkg) {
    setSelectedPackage(pkg);
    setCurrentSlide(0);
  }
  setIsOpenView(!isOpenView);
}

const getImageArray = (pkg) => {
  if (!pkg) return [];
  const images = [pkg.image];
  if (pkg.subImage && pkg.subImage[0]) {
    if (pkg.subImage[0].imageOne) images.push(pkg.subImage[0].imageOne);
    if (pkg.subImage[0].imageTwo) images.push(pkg.subImage[0].imageTwo);
    if (pkg.subImage[0].imageThree) images.push(pkg.subImage[0].imageThree);
    if (pkg.subImage[0].imageFour) images.push(pkg.subImage[0].imageFour);
  }
  return images;
};

const nextSlide = () => {
  if (selectedPackage) {
    const images = getImageArray(selectedPackage);
    setCurrentSlide((prev) => (prev + 1) % images.length);
  }
};

const prevSlide = () => {
  if (selectedPackage) {
    const images = getImageArray(selectedPackage);
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  }
};

const goToSlide = (index) => {
  setCurrentSlide(index);
};

const handleBookNow = (pkg)=>{
  const message = buildPackageMessage(pkg || {})
  openWhatsApp(message)
}

  return (
    <div className="anniversary-section">
      {isOpenView && selectedPackage ? (
        <>
          <div className="slider-overlay" onClick={openView}></div>
          <div className="product-slider-view">
            <div className="slider-view-header">
              <h2 className="slider-view-title">{selectedPackage.title}</h2>
              <button className="slider-close-btn" onClick={openView} aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="product-image-slider">
              <div className="slider-container-wrapper">
                <button className="slider-nav-btn slider-prev" onClick={prevSlide} aria-label="Previous">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                  </svg>
                </button>
                
                <div className="slider-images-container">
                  <div 
                    className="slider-images-track" 
                    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                  >
                    {getImageArray(selectedPackage).map((image, index) => (
                      <div key={index} className="slider-image-slide">
                        <img 
                          src={image} 
                          alt={`${selectedPackage.title} - Image ${index + 1}`} 
                          loading={index === 0 ? "eager" : "lazy"} 
                          decoding="async"
                          fetchPriority={index === 0 ? "high" : "auto"}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <button className="slider-nav-btn slider-next" onClick={nextSlide} aria-label="Next">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </button>
              </div>

              {getImageArray(selectedPackage).length > 1 && (
                <div className="slider-dots-container">
                  {getImageArray(selectedPackage).map((_, index) => (
                    <button
                      key={index}
                      className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>

            <div className="slider-view-footer">
              <p className="slider-description">{selectedPackage.description}</p>
              <button className="book-now-btn-large" onClick={() => handleBookNow(selectedPackage)}>
                Book Now
              </button>
            </div>
          </div>
        </>
      ) : null}
      <div className="section-header">
        <h2 className="section-title">{sectionTitle}</h2>
        <button 
          className="view-all-link" 
          onClick={(e) => {
            e.preventDefault();
            // Determine category from sectionTitle
            let category = '';
            if (sectionTitle.toLowerCase().includes('birthday')) {
              category = 'birthday';
            } else if (sectionTitle.toLowerCase().includes('wedding')) {
              category = 'wedding';
            } else if (sectionTitle.toLowerCase().includes('anniversary')) {
              category = 'anniversary';
            }
            if (onNavigate && category) {
              onNavigate('products', category);
            }
          }}
        >
          View All
        </button>
      </div>
  {/* Horizontal scroll row */}
  <div className="anniversary-row">
        {DataPackages && DataPackages.map((pkg, index) => (
          <div key={pkg.id} className="anniversary-card">
            <div className="card-image" onClick={() => openView(pkg)}>
              <img 
                src={pkg.image} 
                alt={pkg.title} 
                loading={index < 4 ? "eager" : "lazy"} 
                decoding="async"
                fetchPriority={index < 2 ? "high" : "auto"}
              />
              {/* <div className="discount-badge">{pkg.discount}% OFF</div> */}
              <div className="discount-badge">View</div>
            </div>
            
            <div className="card-content">
              <h3 className="card-title">{pkg.title}</h3>
              <p className="card-description">{pkg.description}</p>
              
              <button className="book-now-btn" onClick={(e)=>{e.stopPropagation(); handleBookNow(pkg)}}>Book Now</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OneSectionDefault;
